import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";

interface RequestTimerProps {
  isLoading: boolean;
  onComplete: (time: number) => void;
}

const RequestTimer: React.FC<RequestTimerProps> = ({
  isLoading,
  onComplete,
}) => {
  const [elapsedTime, setElapsedTime] = useState<number>(0);
  const [finalTime, setFinalTime] = useState<number | null>(null);

  // Separate effect for handling timer
  useEffect(() => {
    console.log("Effect running, isLoading:", isLoading);
    let intervalId: NodeJS.Timeout | undefined;

    if (isLoading) {
      // Reset times when loading starts
      setElapsedTime(0);
      setFinalTime(null);

      // Start the timer
      intervalId = setInterval(() => {
        setElapsedTime((prev) => prev + 1);
      }, 1000);

      console.log("Timer started");
    }

    // Cleanup function
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
        console.log("Timer cleared");
      }
    };
  }, [isLoading]); // Only depend on isLoading

  // Separate effect for handling completion
  useEffect(() => {
    if (!isLoading && elapsedTime > 0 && finalTime === null) {
      setFinalTime(elapsedTime);
      onComplete(elapsedTime);
      console.log("Timer completed at:", elapsedTime);
    }
  }, [isLoading, elapsedTime, finalTime, onComplete]);

  const formatTime = (seconds: number): string => {
    const mins: number = Math.floor(seconds / 60);
    const secs: number = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };

  if (!isLoading && !finalTime) return null;

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="body2" color="text.secondary">
        {isLoading
          ? `Request time: ${formatTime(elapsedTime)}`
          : `Request completed in ${finalTime ? formatTime(finalTime) : "unknown"}`}
      </Typography>
    </Box>
  );
};

export default RequestTimer;
